import React, { useEffect, useState, memo } from 'react';
const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
export const CountdownBadge = memo(function CountdownBadge() {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    if (typeof document !== 'undefined') {
      const storedCount = getCookie('copiesLeft');
      return storedCount ? parseInt(storedCount) : 25;
    }
    return 25;
  });
  useEffect(() => {
    if (!getCookie('copiesLeft')) {
      setCookie('copiesLeft', '25', 30);
    }
    let intervalId: ReturnType<typeof setInterval>;
    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        setCopiesLeft(prevCount => {
          const newCount = prevCount > 3 ? prevCount - 1 : 3;
          setCookie('copiesLeft', newCount.toString(), 30);
          return newCount;
        });
      }, 5000);
    }, 2000);
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className="inline-flex items-center gap-2 bg-spiritual-800/80 backdrop-blur-sm text-spiritual-300 font-body font-bold px-4 py-2 rounded-full border border-spiritual-400/30 shadow-lg" data-id="element-14">
      <span className="relative flex h-2.5 w-2.5" data-id="element-15">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-spiritual-400 opacity-75" data-id="element-16" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-spiritual-400" data-id="element-17" />
      </span>
      Solo {copiesLeft} copias disponibles
    </div>;
});